import { SectionLabel } from '@/components/marketing/v2/SectionLabel';

const BEFORE_ITEMS: ReadonlyArray<string> = [
  'Réseau coupé = ventes perdues',
  'Mobile Money calculé à la main',
  'Stock faux dès J+2 · cahier perdu',
  'Aucune visibilité multi-boutiques',
];

const AFTER_ITEMS: ReadonlyArray<string> = [
  'Ventes offline · sync dès retour réseau',
  'Orange · MTN · Wave intégrés à la caisse',
  'Stock temps réel — 1 vérité pour tout',
  'Dashboard multi-shops depuis ton téléphone',
];

export default function BeforeAfterSection() {
  return (
    <section className="bg-paper py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <SectionLabel className="justify-center">Du chaos → au contrôle</SectionLabel>
          <h2 className="mt-6 font-marketing-display text-[clamp(34px,4.6vw,60px)] font-bold leading-[1] tracking-[-0.035em] text-charcoal-800">
            Arrête de <span className="underline-lime">perdre du CA</span>
            <br className="hidden md:block" /> sur des détails évitables.
          </h2>
          <p className="mt-5 font-marketing-body text-lg text-charcoal-600">
            Ce que tu vivais avant. Ce que tu vis avec Velko.
          </p>
        </div>

        <div className="mt-16 grid gap-8 md:grid-cols-2">
          {/* BEFORE */}
          <div className="relative border-2 border-charcoal-800 bg-paper p-8 shadow-neobrutal-6 md:p-10">
            <div className="absolute -top-4 left-6 inline-flex items-center gap-2 border-2 border-charcoal-800 bg-white px-3 py-1 font-marketing-mono text-[11px] font-bold uppercase tracking-[0.12em] text-charcoal-600 shadow-neobrutal-2">
              <span className="h-2 w-2 bg-terracotta-500" />
              Avant
            </div>
            <h3 className="mt-4 font-marketing-display text-2xl font-bold text-charcoal-800 md:text-[28px]">
              Caisse traditionnelle
            </h3>
            <p className="mt-2 font-marketing-body text-[15px] text-charcoal-600">
              Ce que vivent la majorité des commerces sans POS adapté.
            </p>
            <ul className="mt-8 space-y-4">
              {BEFORE_ITEMS.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 bg-white text-terracotta-500">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                    >
                      <path d="M3 3l6 6" />
                      <path d="M9 3l-6 6" />
                    </svg>
                  </span>
                  <span className="font-marketing-body text-[15px] text-charcoal-700 md:text-base">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* AFTER */}
          <div className="relative border-[3px] border-lime-600 bg-lime-500/10 p-8 shadow-neobrutal-10 md:p-10">
            <div className="absolute -top-4 left-6 inline-flex items-center gap-2 border-2 border-charcoal-800 bg-lime-500 px-3 py-1 font-marketing-mono text-[11px] font-bold uppercase tracking-[0.12em] text-charcoal-800 shadow-neobrutal-2">
              <span className="h-2 w-2 rounded-full bg-charcoal-800" />
              Avec Velko
            </div>
            <h3 className="mt-4 font-marketing-display text-2xl font-bold text-charcoal-800 md:text-[28px]">
              Ta caisse augmentée
            </h3>
            <p className="mt-2 font-marketing-body text-[15px] text-charcoal-700">
              Ce que tu vis quand tu installes Velko. Dès aujourd'hui.
            </p>
            <ul className="mt-8 space-y-4">
              {AFTER_ITEMS.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 flex-shrink-0 items-center justify-center border-2 border-charcoal-800 bg-white text-lime-600">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.8"
                    >
                      <path d="M2.5 6l2.5 2.5 5-5" />
                    </svg>
                  </span>
                  <span className="font-marketing-body text-[15px] font-medium text-charcoal-800 md:text-base">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
